import { Modal, Button, Textarea, Select } from "flowbite-react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useRespondContestMaintenance } from "../../hooks";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";

interface RespondContestModalProps {
  contestId: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const validationSchema = Yup.object({
  resolution: Yup.string()
    .min(5, "A resposta deve ter pelo menos 5 caracteres")
    .required("Campo obrigatório"),
  status: Yup.string().required("Campo obrigatório"),
});

export default function RespondContestModal({
  contestId,
  isOpen,
  setIsOpen,
}: RespondContestModalProps) {
  const { mutate, isPending } = useRespondContestMaintenance();

  const handleClose = () => setIsOpen(false);

  return (
    <Modal show={isOpen} onClose={handleClose}>
      <Modal.Header>
        <h2 className="dark:text-black">Responder Contestação</h2>
      </Modal.Header>
      <Formik
        initialValues={{ resolution: "", status: "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          mutate(
            {
              contestId,
              resolution: values.resolution,
              status: values.status,
            },
            {
              onSuccess: () => {
                handleClose();
              },
              onError: () => {
                handleClose();
              },
            }
          );
        }}
      >
        {({ values, handleChange }) => (
          <Form>
            <Modal.Body>
              <Textarea
                name="resolution"
                rows={4}
                placeholder="Digite sua resposta aqui..."
                value={values.resolution}
                onChange={handleChange}
                style={{ color: "black" }}
              />

              <Select
                className={"text-black mt-4"}
                name="status"
                value={values.status}
                onChange={handleChange}
                style={{ color: "black" }}
              >
                <option value="">Selecione um status</option>
                <option value="APPROVED">Aprovar</option>
                <option value="REJECTED">Rejeitar</option>
              </Select>
            </Modal.Body>

            <Modal.Footer>
              <ButtonWithLoader type="submit" isLoading={isPending}>
                Enviar Resposta
              </ButtonWithLoader>
              <Button color="gray" type="button" onClick={handleClose}>
                Cancelar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
